<template>
  <div>
    <card title="Filtros">
      <div class="row mt-n2">
        <SearchFieldSelector
          :default-start-date="defaultStartDate"
          :default-end-date="defaultEndDate"
          :options="dateSelectOptions"
          class="search-date-select-options"
          :clean-date="cleanDate"
          @updateSearchValue="setDate"
        />

        <SearchFieldSelector
          class="search-multiple-text"
          :options="selectOptions"
          @updateSearchValue="setMultipleTextSearch"
        />

        <md-button
          class="btn btn-primary"
          @click="submitSearch"
        >
          <svg-loader :src="'/static/images/icon-generate-list.svg'" />
          Listar
        </md-button>
      </div>
    </card>
  </div>
</template>

<script>
import moment from 'moment'
import { mapActions, mapGetters } from 'vuex'
import Card from '@/components/common/Card.vue'
import SearchFieldSelector from '@/components/common/SearchFieldSelector.vue'
import { RECOLLECT_PERIOD_DAYS_DEFAULT } from '@/enums'
import notify from '../../api/notification'

export default {
  name: 'RecollectFilter',

  components: {
    Card,
    SearchFieldSelector
  },

  data() {
    return {
      today: new Date(),
      dateSelected: { start: this.startDate, end: this.endDate },

      dateSelectOptions: [
        {
          itemValue: 'TD',
          value: 'transferDate',
          label: 'Período',
          placeholder: 'Período',
          limitDays: 1827,
          type: 'date'
        }
      ],
      selectOptions: [
        {
          value: 'patientName',
          label: 'Nome do Paciente',
          placeholder: 'Nome do Paciente',
          limitDays: null,
          singleDate: false,
          selected: false
        },
        {
          value: 'osAlvaro',
          label: 'OS Alvaro',
          placeholder: 'Os Alvaro',
          limitDays: null,
          singleDate: false,
          selected: false
        },
        {
          value: 'osLis',
          label: 'OS Lis',
          placeholder: 'OS Lis',
          limitDays: null,
          singleDate: false,
          selected: false
        }
      ],
      patient: undefined,
      startDateNameRoot: undefined,
      endDateNameRoot: undefined,
      osLis: undefined,
      osAlvaro: undefined,
      status: undefined,
      previousDays: 45,
      offset: 0,
      cleanDate: 0
    }
  },

  computed: {
    ...mapGetters(['collectionPointLabels', 'toggle', 'recollectParans']),

    defaultStartDate: function () {
      return moment(this.today).subtract(RECOLLECT_PERIOD_DAYS_DEFAULT, 'days').toDate()
    },
    defaultEndDate: function () {
      return this.today
    },

    recollectFilters() {
      const { start, end } = this.dateSelected
      return {
        startDate: start ?? undefined,
        endDate: end ?? undefined,
        patient: this.patient ?? undefined,
        osLis: this.osLis ?? undefined,
        osAlvaro: this.osAlvaro ?? undefined,
      }
    },
  },

  async mounted() {
    this.setInitialFilters()
    this.getAllTotalRecollects()
  },

  methods: {
    ...mapActions(['fetchRecollectListForSubmit', 'selectRecollectParams', 'getAllTotalRecollects']),

    setInitialFilters() {
      this.dateSelected = { start: this.defaultStartDate, end: this.defaultEndDate }
      this.selectRecollectParams({ ...this.recollectParans, ...this.recollectFilters, previousDays: undefined });
    },

    setDate(e) {
      const { date } = e
      if (this.isRangeValid(date)) {
        this.dateSelected = date
      } else {
        this.dateSelected = {
          start: this.today,
          end: this.today
        }

        this.cleanDate++

        if (this.cleanDate > 1) {
          this.cleanDate = 0
        }

        notify({
          title: 'AVISO:',
          message: `Selecione um período de até ${RECOLLECT_PERIOD_DAYS_DEFAULT} dias.`
        })
      }
    },

    isRangeValid(date) {
      if (!date.start || !date.end) {
        return false
      }
      const startDate = moment(date.start)
      const endDate = moment(date.end)
      const diffInDays = endDate.diff(startDate, 'days')

      if (diffInDays > RECOLLECT_PERIOD_DAYS_DEFAULT) {
        return false
      }

      return true
    },

    setMultipleTextSearch(e) {
      this.patient = undefined
      this.osLis = undefined
      this.osAlvaro = undefined

      switch (e?.value) {
        case 'patientName':
          this.patient = e?.query
          break
        case 'osAlvaro':
          this.osAlvaro = e?.query
          break
        case 'osLis':
          this.osLis = e?.query
          break
      }
    },

    async submitSearch() {
      this.selectRecollectParams({ ...this.recollectParans, ...this.recollectFilters, previousDays: undefined });
      await this.fetchRecollectListForSubmit();
    }
  }
}
</script>

<style lang="scss" scoped>
:deep(.card-form__container) {
  padding-top: 8px !important;
}

.w-100 {
  width: 100%;
}

.row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 16px;
  width: 100%;

  div {
    flex: 1 1 auto;
    margin: 0;
  }
}

.search-date-select-options {
  max-width: 30%;
}
</style>
